import {IComponentController, IHttpPromise, IScope} from "angular";
import {LqbPricerLogService} from "../../../lqb_pricer_parameters_service/service/LqbPricerLogService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {
    LqbPricerLogServiceName,
    LqbPricerParameterServiceName,
    ToastNotificationServiceName
} from "../../../utils/names/serviceNames";
import {LqbPricerLogParametersService} from "../../../logging_calculation/service/LqbPricerLogParametersService";

interface LqbPricerLogInfoScope extends IScope {
    pricerExecutionLog: any;
}

export class LqbPricerLogInfo implements IComponentController {

    private $scope: LqbPricerLogInfoScope;
    private lqbPricerLogService: LqbPricerLogService;
    private calculationExecutionLogId: number;
    private toastNotificationService: ToastNotificationService;
    private lqbParameterService: LqbPricerLogParametersService;
    private lqbParametersMap: any;

    public static instance = {
        controller: ['$scope', LqbPricerLogServiceName, ToastNotificationServiceName, LqbPricerParameterServiceName, LqbPricerLogInfo],
        template: require('./LqbPricerLogInfo.html'),
        bindings: {
            calculationExecutionLogId: '<'
        }
    };

    constructor($scope: LqbPricerLogInfoScope,
                lqbPricerLogService: LqbPricerLogService,
                toastNotificationService: ToastNotificationService,
                lqbParameterService: LqbPricerLogParametersService) {
        this.$scope = $scope;
        this.lqbParameterService = lqbParameterService;
        this.lqbPricerLogService = lqbPricerLogService;
        this.toastNotificationService = toastNotificationService;
    }

    $onInit(): void {
        let parameterMapPromise: any = this.lqbParameterService.getLqbPricerParametersNames()
            .then(resp => {
                this.lqbParametersMap = resp.data;
                return resp.data;
            });

        this.lqbPricerLogService.getCalculationLqbPricerLog(this.calculationExecutionLogId)
            .then(resp => {
                this.resolvePricerRequest(resp.data.loanRequest, parameterMapPromise);
            }, error => {
                this.toastNotificationService.generateErrorMessage(error);
            })
    }

    resolvePricerRequest = (pricerRequestLog, promise: IHttpPromise<any>) => {
        promise.then(parametersNameMap => {
            let reqNames = Object.keys(pricerRequestLog);
            let pricerReq = {};
            for (let parmName of reqNames) {
                let key = parametersNameMap[parmName];
                if (key) {
                    pricerReq[key] = pricerRequestLog[parmName];
                }
            }
            this.$scope.pricerExecutionLog = pricerReq;
        });
    }


}